var map = {
	"./bilibili.svg": 40553,
	"./boomstream.svg": 71772,
	"./breakerstv.svg": 34224,
	"./custom.svg": 64688,
	"./cybergame.svg": 87590,
	"./discord.png": 46377,
	"./discord.svg": 61307,
	"./djlive.png": 4797,
	"./dlive.svg": 58525,
	"./facebook-live.svg": 41268,
	"./gg.svg": 37643,
	"./instagib.svg": 88224,
	"./lahzenegar.svg": 72554,
	"./linkedin.svg": 34883,
	"./liveedu.svg": 65989,
	"./livehouse.svg": 5493,
	"./livestream.svg": 4531,
	"./meridix.svg": 1547,
	"./mixcloud.svg": 12744,
	"./mixer.svg": 13104,
	"./mobcrush.svg": 1218,
	"./nimotv.png": 43224,
	"./nimotv.svg": 88808,
	"./now.svg": 79719,
	"./periscope.png": 91063,
	"./periscope.svg": 42413,
	"./phonelivestreaming.svg": 74247,
	"./picartotv.svg": 89923,
	"./sportscastr.svg": 54573,
	"./steam.svg": 91139,
	"./switchboard.svg": 95811,
	"./thetatv.svg": 61389,
	"./trovo.svg": 16335,
	"./twitch.svg": 86352,
	"./twitter.svg": 28154,
	"./ustream.svg": 14198,
	"./vaperstv.svg": 97112,
	"./vaughnlive.svg": 38042,
	"./vimeo-white-12dfb0dc.svg": 84966,
	"./vimeo.svg": 93903,
	"./vimmtv.png": 44050,
	"./vimmtv.svg": 76410,
	"./vk.png": 92804,
	"./vk.svg": 49868,
	"./webtv.svg": 27435,
	"./younow.svg": 41758,
	"./youtube.svg": 97312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17537;